@let task = task$ | async;
@let comments = comments$ | async;

<app-layout [isProducerArea]="true">
  <app-page-header
    [title]="'Solicitações'"
    [titleIcon]="'pi pi-list-check'"
    [breadcrumbs]="[
      { label: 'Início', link: '/', icon: 'pi pi-home' },
      { label: 'Área do produtor', link: '/producer-area', icon: 'pi pi-chart-bar' },
      { label: 'Solicitações', link: '/solicitations', icon: 'pi pi-list-check' },
      { label: 'Detalhes', icon: 'pi pi-eye' },
    ]"></app-page-header>

  <div class="solicitation-detail container-fluid">
    @if (task) {
      <div class="solicitation-detail__layout">
        <!-- Left Column -->
        <aside class="solicitation-detail__sidebar">
          <button type="button" class="solicitation-detail__back-button" (click)="goBack()">
            <i class="pi pi-chevron-left"></i>
          </button>

          <app-task-info-card [task]="task" />

          <!--
            TODO: confirmar se a justificativa enviada pelo produtor será exibida na solicitação.
            O endpoint POST /events/:id/cancel ainda não recebe o motivo, então a task não traz a mensagem.
            @else if (task.task_type === TaskType.EVENT_CANCELLATION) {
              <app-cancellation-info-card [description]="task.description" />
            }
          -->
          @if (task.task_type === TaskType.EVENT_CREATION) {
            <app-event-info-card [event]="task.event" />
          } @else if (task.task_type === TaskType.BANK_ACCOUNT_UPDATE) {
            <app-bank-account-info-card [changes]="task.requested_changes" />
          } @else if (
            (task.task_type === TaskType.WITHDRAWAL || task.task_type === TaskType.REFUND) && task.bank_account
          ) {
            <app-bank-account-info-card [changes]="task.bank_account" title="DADOS BANCÁRIOS" />
          }
        </aside>

        <!-- Right Column -->
        <main class="solicitation-detail__main">
          <app-task-comments
            [comments]="comments ?? []"
            [closed]="task.status !== 'pending'"
            [closedAt]="task.updated_at"
            (commentSubmit)="handleCommentSubmit($event)" />
        </main>
      </div>
    } @else {
      <div class="solicitation-detail__layout">
        <aside class="solicitation-detail__sidebar">
          <p-skeleton shape="circle" width="36px" height="36px" />
          <p-skeleton height="180px" borderRadius="8px" />
          <p-skeleton height="160px" borderRadius="8px" />
        </aside>
        <main class="solicitation-detail__main solicitation-detail__main--skeleton">
          <p-skeleton width="200px" height="24px" />
          <p-skeleton height="100%" borderRadius="8px" />
          <p-skeleton height="80px" borderRadius="8px" />
        </main>
      </div>
    }
  </div>
</app-layout>
